export default __webpack_public_path__ + "d8686220f5ca0af72bde130fdade7b37.png";